module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-autopilot-es.acf3f477.vtt";